import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { DeletePublicPasswordConfirmModalProps } from './DeletePublicPasswordConfirmModal.types';

export const renderDeletePublicPasswordConfirmModal = (data: DeletePublicPasswordConfirmModalProps) =>
    openPopupHelper({ popupName: popupNames.DELETE_PUBLIC_PASSWORD, data });
